export default function Origen(){
    return(
        <div className="mt-5">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                        <h1 className="titulo text-center">HISTORIA</h1>
                    </div>
                </div>
            </div>

            <hr></hr>

            <div className="container">
                <div className="row gy-4">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                        <img src="/imagenes/brucewayne-tragedy.jpg" alt="brucewayne-tragedy" className="img-fluid shadow"></img>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 col-xl-12 bg-dark text-white p-3">
                        <p>
                            Con tan solo 6 u 8 años, Bruce Wayne presenció el asesinato 
                            de sus padres, Thomas y Martha Wayne, a manos de un 
                            delincuente en un callejón de Ciudad Gótica tras salir 
                            del Teatro Monarch.
                        </p>
                        <p>
                            Este trágico suceso marcó profundamente su vida. El trauma 
                            provocó una juventud llena de rabia, autolesiones y 
                            conflictos internos, pero también despertó en 
                            él una determinación absoluta: usar su fortuna, su 
                            entrenamiento y su voluntad para combatir el crimen 
                            como Batman.
                        </p>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-6 col-xl-6 col-lg-6">
                        <h1 className="titulo text-center">BRUCE WAYNE</h1>
                        <hr></hr>
                        <p>
                            Bruce Wayne es un empresario multimillonario y presidente 
                            corporativo de Empresas Wayne, una de las compañías más 
                            influyentes de Ciudad Gótica. Ante la sociedad Bruce tiene 
                            la imagen de un filántropo que financia proyectos sociales 
                            y apoya diversas iniciativas por mejorar la ciudad.
                        </p>
                        <p>
                            Sin embargo, esta vida pública también funciona como una 
                            fachada. En secreto, Bruce Wayne dedica su tiempo y 
                            recursos a su verdadera misión: combatir el crimen como 
                            Batman. Su inteligencia, disciplina y entrenamiento 
                            lo convierten en uno de los vigilantes más temidos por 
                            los criminales.
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <img src="/imagenes/bruce-wayne.jpg" className="img-fluid" alt="bruce-wayne"></img>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <h1 className="titulo text-center">BATMAN</h1>
                        <hr></hr>
                        <p>
                            Batman es el vigilante que asecha las sombras de Ciudad 
                            Gótica. Sin poseer superpoderes, se ha convertido en uno 
                            de los mayores protectores de la ciudad gracias a su 
                            inteligencia, disciplina y años de entrenamiento físico y 
                            mental.
                        </p>
                        <p>
                            Cubierto por la oscuridad y el símbolo del murciélago, 
                            Batman utiliza el miedo como arma contra los criminales. 
                            Para muchos ciudadanos es una leyenda; para los 
                            delincuentes, es un presagio. Una silueta que se mueve 
                            entre las sombras y tejados. Cuando cae la noche llega el 
                            terror para quienes creían poder esconderse en la oscuridad.
                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <img src="/imagenes/batman.jpg" className="img-fluid" alt="batman"></img>
                    </div>
                </div>
            </div>
        </div>
    )
}